import { requestBuilder } from '../../http/RequestBuilder';

export interface DeleteSpinwheelUserResponse {
    success: boolean;
}

export const useDeleteSpinwheelUser =
    requestBuilder.mutation<DeleteSpinwheelUserResponse>({
        endpoint: '/api/spinwheel/user',
        method: 'DELETE',
    });
